import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import Content from "./Content";
import Page from "../../../components/Page";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
  },
}));
function NewSession() {
  const { classes } = useStyles();
  return (
    <Page className={classes.root} title={"New Session"}>
      <Box
        height={"100%"}
        display={"flex"}
        flexDirection={"column"}
        overflow={"hidden"}
        position={"relative"}>
        <Header />
        <Content />
      </Box>
    </Page>
  );
}

export default NewSession;
